<template>
  <div class="page-detail-header">
    <div class="page-detail-header-button">
      <div class="header-button-wrapper">
        <RfButtonNew
          v-if="showEnableDisable"
          type="quaternary"
          size="xx-small"
          :data-cy="item.is_enabled ? 'rf-detail-header--disable' : 'rf-detail-header--enable'"
          class="border-beige-90 text-beige-90! [&:not(:disabled)_.rf-icon]:fill-beige-90!"
          :disabled="userStore.isDisabledWithMessage"
          @click="emit('enableItem', !item.is_enabled)"
        >
          <RfPauseAlterIcon v-if="item.is_enabled" class="h-5! w-5!" />
          <RfPlayAlterIcon v-else class="h-5! w-5!" />
          {{ item.is_enabled ? "Disable" : "Enable" }}
        </RfButtonNew>

        <RfButtonNew
          type="quaternary"
          size="xx-small"
          :disabled="
            isSystemSegment && !userStore.isDisabledWithMessage
              ? 'System segments cannot be cloned. Only one segment of this type is allowed per app.'
              : userStore.isDisabledWithMessage
          "
          class="border-beige-90 text-beige-90 [&:not(:disabled)_.rf-icon]:fill-beige-90!"
          @click="emit('clone')"
        >
          <RfCopyIcon class="h-6! w-6!" />
          Clone
        </RfButtonNew>

        <v-dialog v-model="showDialog" persistent width="500">
          <template #activator="{ props }">
            <RfButtonNew
              v-if="!deleteOff"
              type="quaternary"
              size="xx-small"
              v-bind="props"
              :disabled="userStore.isDisabledWithMessage || locked"
              class="border-vermillion-50 text-vermillion-50 [&:not(:disabled)_.rf-icon]:fill-vermillion-50!"
            >
              <RfDeleteIcon class="h-6! w-6!" />
              Delete
            </RfButtonNew>
          </template>
          <v-card>
            <v-card-title class="headline">Are you sure you want to delete?</v-card-title>
            <v-card-text>
              Deleting this Segment removes all information about this Segment. This cannot be
              undone.
            </v-card-text>
            <v-card-actions class="modal-card-actions-div">
              <v-btn
                size="large"
                class="cancel-btn"
                variant="outlined"
                style="width: 100px"
                @click="closeDialog"
                >Cancel</v-btn
              >
              <v-btn
                size="large"
                variant="flat"
                color="error"
                style="width: 150px"
                @click="submitDialog"
                >Delete</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useUserStore } from "@/pinia/userStore";
import { ref, computed } from "vue";
import RfButtonNew from "./buttons/RfButtonNew.vue";
import RfDeleteIcon from "./icons/RfDeleteIcon.vue";
import RfCopyIcon from "./icons/RfCopyIcon.vue";
import RfPauseAlterIcon from "./icons/RfPauseAlterIcon.vue";
import RfPlayAlterIcon from "./icons/RfPlayAlterIcon.vue";

const emit = defineEmits(["submitDelete", "clone", "enableItem"]);
const props = defineProps({
  locked: { type: Boolean, default: false },
  deleteOff: { type: Boolean, default: false },
  item: { type: Object, required: true },
  showEnableDisable: { type: Boolean, default: true },
});

const userStore = useUserStore();
const showDialog = ref(false);
const closeDialog = () => (showDialog.value = false);
const submitDialog = () => {
  emit("submitDelete");
  closeDialog();
};

const isSystemSegment = computed(() => props.item?.segment_type?.startsWith("system_"));
</script>
